import * as packages from './packages';
import * as account from './account';
import * as voices from './voices';
import * as paymentMethods from './paymentMethods';
import * as banks from './banks';
import * as orders from './orders';
import * as upload from './upload';
import * as requests from './requests';
import * as synthesis from './synthesis';
import * as version from './version';
import * as user from './user';
import * as vouchers from './voucher';
import * as banners from './banners';
import * as warning from './warning';
import * as clientPause from './clientPause';
import * as captionTemplate from './captionTemplate';
import * as font from './font';
import * as country from './country';
import * as backgroundMusic from './backgroundMusic';
import * as blackWords from './blackWord';
import * as devices from './device';
import * as stt from './stt';
import * as affiliateMarketer from './affiliateMarketer';
import * as affiliateTransaction from './affiliateTransaction';
import * as files from './files';
import * as dubbing from './dubbing';
import * as feedbacks from './feedbacks';
import * as subscription from './subscription';
import * as adsProvider from './adsProvider';
import * as keycloak from './keycloak';
import * as voiceCloning from './voiceCloning';
import * as sampleScripts from './sampleScripts';
import * as loginCode from './loginCode';
import * as survey from './survey';
import * as project from './project';
import * as referral from './referral';
import * as instantVoiceTraining from './instantVoiceTraining';
import * as ttsPreset from './ttsPreset';
import * as language from './language';
import * as favouriteVoices from './favouriteVoices';
import * as redeem from './redeem';
import * as transactionsHistory from './transactionsHistory';
import * as leaderboard from './leaderboard';
import * as revenue from './revenue';
import * as rewardTransactions from './rewardTransactions';
import * as faq from './faq';
import * as tasks from './tasks';
import * as session from './session';
import * as apps from './apps';
import * as pronunciationCheck from './pronunciationCheck';
import * as notification from './notification';
import * as topPaidEvent from './topPaidEvent';

export default {
  project,
  survey,
  adsProvider,
  packages,
  account,
  voices,
  paymentMethods,
  banks,
  orders,
  upload,
  requests,
  synthesis,
  version,
  user,
  vouchers,
  banners,
  warning,
  clientPause,
  country,
  backgroundMusic,
  blackWords,
  devices,
  stt,
  affiliateMarketer,
  affiliateTransaction,
  files,
  dubbing,
  feedbacks,
  subscription,
  keycloak,
  voiceCloning,
  sampleScripts,
  loginCode,
  referral,
  instantVoiceTraining,
  ttsPreset,
  language,
  favouriteVoices,
  redeem,
  transactionsHistory,
  leaderboard,
  revenue,
  rewardTransactions,
  faq,
  tasks,
  session,
  apps,
  pronunciationCheck,
  notification,
  captionTemplate,
  font,
  topPaidEvent,
};
